import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Badge, Modal } from 'react-bootstrap';
import MessageForm from './MessageForm';
import { deleteMessagePolicy } from '../../../actions/message-policy';
import { DataTable, Icon, Span } from '../../widgets';

const MessageAlertRow = ({ data, index, farmId }) => {
    const [show, setShow] = useState(false);
    const [showDeleteModal, setDeleteModal] = useState(false);

    const dispatch = useDispatch();

    const handleDeleteConfim = () => {
        const params = {
            policy_id: data.policy_id,
            farm_uuid: farmId
        };

        dispatch(deleteMessagePolicy(params));
    };

    const getNumber = (num) => {
        if (!num) return '-';
        // let phone = num.split('-');
        // return phone && phone.length > 0 ? phone[1] : num;

        return num
    };

    const getName = (item) => {
        return item && item.toString().trim().length !== 0 ? item.split('_').join(' ') : <span style={{ color: 'red' }}>Unknown</span>;
    };

    if (!data) return <></>;

    return (
        <>
            <DataTable.Row                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        >
                <DataTable.Cell>{index + 1}</DataTable.Cell>
                <DataTable.Cell>{getName(data.entity_name)}</DataTable.Cell>
                <DataTable.Cell>{data.entity_type_name}</DataTable.Cell>

                <DataTable.Cell>
                    {data.phones.map(item => <Badge style={{ outline: 'solid 1px #878787' }} className='mx-1 badge text-dark' bg='light' text='dark' >{getNumber(item)}</Badge>)}
                </DataTable.Cell>

                <DataTable.Cell>{Object.keys(data.policy_config).map(item => <Badge variant={data.policy_config[item] === 0 ? 'danger' : 'success'} className='mx-1' style={{ textTransform: 'capitalize' }}>{getName(item)}</Badge>)}</DataTable.Cell>
                <DataTable.Cell style={{ width: '64px' }} className='center'>
                    <Icon
                        className='fa fa-pencil mr-1 cursor-pointer'
                        title='Edit'
                        onClick={() => setShow(!show)} />
                    <Span className='btn-icon'><i className='fa fa-trash' title='Delete'
                        onClick={() => setDeleteModal(true)}></i>
                    </Span>
                </DataTable.Cell>
            </DataTable.Row>
            <Modal
                show={show}
                backdrop='static'
                className='equipment-modal-form'>
                <MessageForm
                    onHide={(e) => setShow(e)}
                    values={data}
                />
            </Modal>

            <Modal.Confirm
                isOpen={showDeleteModal}
                onConfirm={handleDeleteConfim}
                iconClassName='fa fa-trash'
                body={`Do you really want to delete ${data.entity_name} SMS configuration?`}
                onHide={() => setDeleteModal(false)}
            />
        </>
    );
};

export default MessageAlertRow;